import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Sidebar from './sidebar';
import Navbar from './navbar';
import Footer from './footer';

const baseURL = process.env.REACT_APP_API_BASE_URL;

const Design = () => {
  const [designs, setDesigns] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Number of items per page

  useEffect(() => {
    // Fetch all designs
    axios.get(`${baseURL}/fetch-design`)
      .then(response => {
        setDesigns(response.data || []); // Default to empty array if response.data is undefined
      })
      .catch(error => {
        console.error('Error fetching designs:', error);
      });
  }, []);

  // Search and filter designs
  const filteredDesigns = designs.filter(design =>
    (design.dname?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
    (design.did?.toString() || '').includes(searchTerm.toLowerCase()) ||
    (design.description?.toLowerCase() || '').includes(searchTerm.toLowerCase())
  );

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredDesigns.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredDesigns.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleDelete = (designId) => {
    // Delete design by ID
    axios.delete(`${baseURL}/delete-design/${designId}`)
      .then(response => {
        // Update the state to remove the deleted design
        setDesigns(designs.filter(design => design.did !== designId));
        // Optionally reset pagination
        if (currentPage > Math.ceil((designs.length - 1) / itemsPerPage)) {
          setCurrentPage(currentPage - 1);
        }
      })
      .catch(error => {
        console.error('Error deleting design:', error);
      });
  };

  return (
    <div className="layout">
      <Sidebar />
      <div className="main-content">
        <Navbar />
        <div className="content">
          <div className='container'>
            <h2>Designs</h2>
            <input
              type="text"
              placeholder="Search by Name or Description..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input-main"
            />
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Image</th>
                  <th>Name</th>
                  <th>Description</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {currentItems.length > 0 ? (
                  currentItems.map(design => (
                    <tr key={design.did}>
                       <td>{design.did}</td>
                      <td>
                        <img
                          src={`${baseURL}/images/design/${design.images}`}
                          alt={design.dname}
                          style={{ height: '50px', objectFit: 'cover' }}
                        />
                      </td>
                      <td>{design.dname || 'No Name'}</td>
                      <td>{design.ds1 || 'No Description'}</td>
                      <td>
                        <div className='d-flex justify-content-between'>
                          <Link to={`/edit-design/${design.did}`} className='btn btn-primary btn-sm'>
                            Edit
                          </Link>
                          </div>
                          </td>
                          <td>
                            <div>
                          <button
                            onClick={() => handleDelete(design.did)}
                            className='btn btn-danger btn-sm'
                          >
                            Delete
                          </button>
                          </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4">No designs found</td>
                  </tr>
                )}
              </tbody>
            </table>
            
            <div className="pagination">
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <span>Page {currentPage} of {totalPages}</span>
              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Design;
